function onReady(callback) {
	document.addEventListener('DOMContentLoaded', callback);
}

function onResize(callback) {
	document.addEventListener('resize', callback);
}

function onScroll(callback) {
	document.addEventListener('scroll', callback);
}


export {onReady, onResize, onScroll}
